export * from "./useApolloClient.js";
export * from "./useLazyQuery.js";
export * from "./useMutation.js";
export * from "./useQuery.js";
export * from "./useSubscription.js";
export * from "./useReactiveVar.js";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/@apollo/client/react/hooks/index.js
// module id = 1997
// module chunks = 69